﻿

$(document).ready(function () {
    var priceGrainResellerAdminOverviewPage = new PriceGrainResellerAdminOverviewPage();
    priceGrainResellerAdminOverviewPage.init();
    $(document).on("change", "select", function () {
        //Check whether option with value  exists
        var option = $("option[value='" + this.value + "']", this);
        if (option && option.length > 0) {
            option
                .attr("selected", true).siblings()
                .removeAttr("selected");
        }

    });
    // enhance table saw to make responsive table
    $(document).trigger("enhance.tablesaw");
});


function renderPriceGrainResellerAdminOverviewTable(title, data) {
    var printWindow = window.open("", "_blank");
    printWindow.document.write('<html><head><title>' + title + '</title>');
    printWindow.document.write("<link rel=\"stylesheet\" href=\"/Static/dist/styles/styles.css\" type=\"text/css\" media=\"all\"/>");
    printWindow.document.write("<style type=\"text/css\">");
    printWindow.document.write("button.my-agreements__collapse-control:not(.is-active) {display: none !important;}");
    printWindow.document.write("button.my-agreements__collapse-control.is-active {padding-bottom: 0px !important;}");
    printWindow.document.write(".ResellerAdminOverviewUnloadingPanel {display: block !important;overflow: visible !important;height:auto !important;max-height: none !important;right: inherit;width:100% !important;}");
    printWindow.document.write(".collapse__target.is-active { display: block;padding-top: 0px !important;padding-right: 0px !important;padding-left: 0px !important;}");
    printWindow.document.write(".ResellerAdminOverviewTerminrubrik:last-child { display: none !important;}");
    printWindow.document.write("table.tblPriceGrainResellerAdminOverviewResults tr:not(.price-grain-reseller-admin-overview-favorite-row){display: none !important;}");
    printWindow.document.write("button.js-toggle:not(.expand-price-grain-reseller-admin-overview-row) {display: none !important;}");
    printWindow.document.write("#priceAreaNameResellerAdminOverview {display: inline-block !important;margin-top: 10px !important;margin-bottom: 10px !important;}");
    printWindow.document.write('</style></head><body>');
    printWindow.document.write(data);
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    setTimeout(function () {
        printWindow.focus();
        printWindow.print();
        printWindow.close();
    }, 3000);
    return true;
}
function printPriceGrainResellerAdminOverviewTable() {
    var btn = $('#printPriceGrainResellerAdminOverviewBtn');

    var overviewHeader = btn.attr('data-overviewHeader');
    var priceAreaHeader = btn.attr('data-priceAreaHeader');
    var priceArea = $('#price-grain-reseller-admin-overview-areas-list li.selected').data('name');
    $("#priceAreaNameResellerAdminOverview > h4").html(priceAreaHeader+": "+priceArea);
    var title = overviewHeader + ' - ' + priceArea;
    renderPriceGrainResellerAdminOverviewTable(title, $('<div/>').append($("#printable-price-grain-reseller-admin-overview-table").clone()).html());
}


var PriceGrainResellerAdminOverviewFunction = PriceGrainResellerAdminOverviewFunction || (function () {
    var blockUI = function () {
        $("#price-grain-reseller-admin-overview-loader").show();
    };
    var unBlockUI = function () {
        $("#price-grain-reseller-admin-overview-loader").hide();
    };

    var disableButtons = function () {
        $("#printPriceGrainResellerAdminOverviewBtn").addClass("disabled-btn");
    };
    var enableButtons = function () {
        $("#printPriceGrainResellerAdminOverviewBtn").removeClass("disabled-btn");
    };

    return {
        blockUI: blockUI,
        unBlockUI: unBlockUI,
        enableButtons: enableButtons,
        disableButtons: disableButtons
    };
})();

var PriceGrainResellerAdminOverviewPage = function () {
    var hidePriceGrainResellerAdminOverview = function () {
        $('.js-show-hide-price-grain-reseller-admin-overview-result').hide();
    };

    var showPriceGrainResellerAdminOverview = function () {
        $('.js-show-hide-price-grain-reseller-admin-overview-result').show();
    };

    var getCurrentlySelectedPriceAreaId = function () {
        return $('#price-grain-reseller-admin-overview-areas-list').attr('data-value');
    };
    var setPriceGrainResellerAdminOverview = function () {
        $('button.js-toggle').each(function (i, priceGrainResellerAdminOverviewRow) {
            var control = $(priceGrainResellerAdminOverviewRow);
            if (control.hasClass('expand-price-grain-reseller-admin-overview-row')) {
                farmday.modules.toggle.show(control);
            }
        });
    };
    var requests = [];
    var fetchPriceGrainResellerAdminOverview = function () {
        hidePriceGrainResellerAdminOverview();
        PriceGrainResellerAdminOverviewFunction.disableButtons();
        PriceGrainResellerAdminOverviewFunction.blockUI();
        $.each(requests, function (index, request) {
            request.abort();
        });
        var tableResult = $("#price-grain-reseller-admin-overview-result");
        requests = [];
        var priceGrainResellerAdminOverviewDefered = $.ajax({
            type: "POST",
            url: "/api/price-grain-reseller-admin-overview/GetPriceGrainResellerAdminOverview",
            async: true,
            cache: false,
            data: JSON.stringify({ priceAreaId: getCurrentlySelectedPriceAreaId() }),
            contentType: "application/json; charset=utf-8",
            dataType: "html",
            success: function (priceGrainResellerAdminOverviewResult) {
                if (priceGrainResellerAdminOverviewResult && priceGrainResellerAdminOverviewResult.length > 0) {
                    tableResult.html(priceGrainResellerAdminOverviewResult);
                    /* little fade in effect */
                    tableResult.fadeIn('fast');
                }
                else {
                    tableResult.html("<div>Det finns inga priser för valt område och datum.</div>");
                }
            },
            error: function (jqXHR, status, exception) {
                console.error("Something went wrong with the AJAX request for fetching price grain overview!" + "</br>" + exception);
                tableResult.html("<h2>Det gick inte att hämta återförsäljare spannmålspriser admin översikt</h2>");

            }
        });

        requests.push(priceGrainResellerAdminOverviewDefered);
        $.when.apply($, requests).then(function () {
            PriceGrainResellerAdminOverviewFunction.unBlockUI();
            PriceGrainResellerAdminOverviewFunction.enableButtons();
            setPriceGrainResellerAdminOverview();
            showPriceGrainResellerAdminOverview();
        });
    };
    var addPriceGrainResellerAdminOverviewEvents = function () {
        $('#price-grain-reseller-admin-overview-areas-list .dropdown li a').on("click", function (e) {
            fetchPriceGrainResellerAdminOverview();
        });

        $('#printPriceGrainResellerAdminOverviewBtn').on("click", function () {
            printPriceGrainResellerAdminOverviewTable();
        });
    };
    var addPriceGrainResellerAdminOverviewFavorite = function (target, priceGrainResellerAdminOverviewFavorite) {
        PriceGrainResellerAdminOverviewFunction.blockUI();
        $.ajax({
            type: "POST",
            url: "/api/price-grain-reseller-admin-overview/AddPriceGrainResellerAdminOverviewFavorite",
            async: true,
            cache: false,
            data: JSON.stringify({ priceGrainResellerAdminOverviewFavorite: priceGrainResellerAdminOverviewFavorite }),
            contentType: "application/json; charset=utf-8",
            success: function (response) {
                if (response) {
                    target.toggleClass("active");
                    var targetRow = target.closest('tr');
                    targetRow.addClass('price-grain-reseller-admin-overview-favorite-row');
                    var parentRow = $('button.js-toggle[data-toggle-target=#' + target.data('pricegroupid') + ']');
                    var tblResult = $('#tblPriceGrainResellerAdminOverviewResults_' + target.data('pricegroupid'));
                    //add expand row if there is any favorite
                    if (parentRow && !parentRow.hasClass('expand-price-grain-reseller-admin-overview-row')) {
                        parentRow.addClass('expand-price-grain-reseller-admin-overview-row');
                    }
                    //add active icon to select all if all rows are favorite
                    if (parentRow && tblResult.find('tr.price-grain-reseller-admin-overview-favorite-row').length == tblResult.find('tr').length) {
                        parentRow.find('button.js-price-grain-reseller-admin-overview-favorite-all').addClass("active");
                    }
                }
            },
            error: function (response) {
                console.error("Något gick fel vid tilläggning av återförsäljare prislista admin översikt favorit.");
            },
            complete: function () {
                PriceGrainResellerAdminOverviewFunction.unBlockUI();
            }
        });
    }
    var removePriceGrainResellerAdminOverviewFavorite = function (target, priceGrainResellerAdminOverviewFavorite) {
        PriceGrainResellerAdminOverviewFunction.blockUI();
        $.ajax({
            type: "POST",
            url: "/api/price-grain-reseller-admin-overview/RemovePriceGrainResellerAdminOverviewFavorite",
            async: true,
            cache: false,
            data: JSON.stringify({ priceGrainResellerAdminOverviewFavorite: priceGrainResellerAdminOverviewFavorite }),
            contentType: "application/json; charset=utf-8",
            success: function (response) {
                if (response) {
                    target.toggleClass("active");
                    var targetRow = target.closest('tr');
                    targetRow.removeClass('price-grain-reseller-admin-overview-favorite-row');
                    var parentRow = $('button.js-toggle[data-toggle-target=#' + target.data('pricegroupid') + ']');
                    var hasFavoriteRows = $('#tblPriceGrainResellerAdminOverviewResults_' + target.data('pricegroupid')).find('tr.price-grain-reseller-admin-overview-favorite-row').length > 0;
                    if (!hasFavoriteRows && parentRow.hasClass('expand-price-grain-reseller-admin-overview-row')) {
                        parentRow.removeClass('expand-price-grain-reseller-admin-overview-row');
                    }
                    //remove active class from select all
                    parentRow.find('button.js-price-grain-reseller-admin-overview-favorite-all').removeClass("active");
                }
            },
            error: function (response) {
                console.error("Något gick fel vid tabort av återförsäljare prislista admin översikt favorit.");
            },
            complete: function () {
                PriceGrainResellerAdminOverviewFunction.unBlockUI();
            }
        });
    }
    var priceGrainResellerAdminOverviewFavoriteClickEvent = function () {
        $(document).on("click", ".js-price-grain-reseller-admin-overview-favorite", function (e) {
            e.stopPropagation();
            var priceGrainResellerAdminOverviewFavorite = {
                PriceAreaId: getCurrentlySelectedPriceAreaId(),
                PriceGroupId: $(this).data("pricegroupid"),
                ItemNumber: $(this).data("itemnumber"),
                Sort: $(this).data("sort")
            }
            if ($(this).hasClass("active")) {
                removePriceGrainResellerAdminOverviewFavorite($(this), priceGrainResellerAdminOverviewFavorite);
            } else {
                addPriceGrainResellerAdminOverviewFavorite($(this), priceGrainResellerAdminOverviewFavorite);
            }

        });

    }
    var addAllPriceGrainResellerAdminOverviewFavorites = function (target) {
        var priceGrainResellerAdminOverviewFavoritesToAdd = [];
        var controls = [];
        PriceGrainResellerAdminOverviewFunction.blockUI();
        var priceAreaId = getCurrentlySelectedPriceAreaId();
        $('#tblPriceGrainResellerAdminOverviewResults_' + target.data('pricegrainreselleradminoverviewrowid')).find('tr:not(.price-grain-reseller-admin-overview-favorite-row)').each(function (i, priceGrainResellerAdminOverviewRow) {
            var control = $(priceGrainResellerAdminOverviewRow).find('button.js-price-grain-reseller-admin-overview-favorite');
            var priceGrainResellerAdminOverviewFavorite = {
                PriceAreaId: priceAreaId,
                PriceGroupId: control.data("pricegroupid"),
                ItemNumber: control.data("itemnumber"),
                Sort: control.data("sort")
            }
            controls.push(control);
            priceGrainResellerAdminOverviewFavoritesToAdd.push(priceGrainResellerAdminOverviewFavorite);
        });
        if (priceGrainResellerAdminOverviewFavoritesToAdd.length > 0) {
            $.ajax({
                type: "POST",
                url: "/api/price-grain-reseller-admin-overview/AddAllPriceGrainResellerAdminOverviewFavorites",
                async: true,
                cache: false,
                data: JSON.stringify({ priceGrainResellerAdminOverviewFavorites: priceGrainResellerAdminOverviewFavoritesToAdd }),
                contentType: "application/json; charset=utf-8",
                success: function (response) {
                    if (response) {
                        target.addClass("active");
                        //adding active class and marking all child rows as favorite
                        for (var index = 0; index < controls.length; index++) {
                            controls[index].addClass('active');
                            var targetRow = controls[index].closest('tr');
                            targetRow.addClass('price-grain-reseller-admin-overview-favorite-row');
                        }
                        //add expand row and open the child row container
                        var parentRow = $('button.js-toggle[data-toggle-target=#' + target.data('pricegrainreselleradminoverviewrowid') + ']');
                        if (parentRow && !parentRow.hasClass('expand-price-grain-reseller-admin-overview-row')) {
                            parentRow.addClass('expand-price-grain-reseller-admin-overview-row');
                            farmday.modules.toggle.show(parentRow);
                        }
                    }
                },
                error: function (response) {
                    console.error("Något gick fel vid tilläggning av återförsäljare prislista admin översikt favorit.");
                },
                complete: function () {
                    PriceGrainResellerAdminOverviewFunction.unBlockUI();
                }
            });
        }
    }
    var removeAllPriceGrainResellerAdminOverviewFavorites = function (target) {
        var priceGrainResellerAdminOverviewFavoritesToRemove = [];
        var controls = [];
        PriceGrainResellerAdminOverviewFunction.blockUI();
        var priceAreaId = getCurrentlySelectedPriceAreaId();
        $('#tblPriceGrainResellerAdminOverviewResults_' + target.data('pricegrainreselleradminoverviewrowid')).find('tr.price-grain-reseller-admin-overview-favorite-row').each(function (i, priceGrainResellerAdminOverviewRow) {
            var control = $(priceGrainResellerAdminOverviewRow).find('button.js-price-grain-reseller-admin-overview-favorite');
            var priceGrainResellerAdminOverviewFavorite = {
                PriceAreaId: priceAreaId,
                PriceGroupId: control.data("pricegroupid"),
                ItemNumber: control.data("itemnumber"),
                Sort: control.data("sort")
            }
            controls.push(control);
            priceGrainResellerAdminOverviewFavoritesToRemove.push(priceGrainResellerAdminOverviewFavorite);
        });
        if (priceGrainResellerAdminOverviewFavoritesToRemove.length > 0) {
            $.ajax({
                type: "POST",
                url: "/api/price-grain-reseller-admin-overview/RemoveAllPriceGrainResellerAdminOverviewFavorites",
                async: true,
                cache: false,
                data: JSON.stringify({ priceGrainResellerAdminOverviewFavorites: priceGrainResellerAdminOverviewFavoritesToRemove }),
                contentType: "application/json; charset=utf-8",
                success: function (response) {
                    if (response) {
                        target.removeClass("active");

                        for (var index = 0; index < controls.length; index++) {
                            controls[index].removeClass('active');
                            var targetRow = controls[index].closest('tr');
                            targetRow.removeClass('price-grain-reseller-admin-overview-favorite-row');
                        }
                        var tblResult = $('#tblPriceGrainResellerAdminOverviewResults_' + target.data('pricegrainreselleradminoverviewrowid'));
                        //if there are no more favorite rows then remove the expand row class
                        var hasFavoriteRows = tblResult.find('tr.price-grain-reseller-admin-overview-favorite-row').length > 0;
                        if (!hasFavoriteRows && target.hasClass('expand-price-grain-reseller-admin-overview-row')) {
                            target.removeClass('expand-price-grain-reseller-admin-overview-row');
                        }
                    }
                },
                error: function (response) {
                    console.error("Något gick fel vid tilläggning av återförsäljare prislista admin översikt favorit.");
                },
                complete: function () {
                    PriceGrainResellerAdminOverviewFunction.unBlockUI();
                }
            });
        }
    }
    var priceGrainResellerAdminOverviewFavoriteAllClickEvent = function () {
        $(document).on("click", ".js-price-grain-reseller-admin-overview-favorite-all", function (e) {
            e.stopPropagation();
            if ($(this).hasClass("active")) {
                removeAllPriceGrainResellerAdminOverviewFavorites($(this));
            } else {
                addAllPriceGrainResellerAdminOverviewFavorites($(this));
            }
        });
    }
    var init = function () {
        addPriceGrainResellerAdminOverviewEvents();
        priceGrainResellerAdminOverviewFavoriteClickEvent();
        priceGrainResellerAdminOverviewFavoriteAllClickEvent();
        var priceAreaId = getCurrentlySelectedPriceAreaId();
        if (priceAreaId && priceAreaId.length > 0) {
            fetchPriceGrainResellerAdminOverview();
        }
    };
    return {
        init: init
    };
};